module.exports = __webpack_public_path__ + "static/media/start.1976fad0.png";